import { useTheme } from '@mui/material';

import CreditCardSVG from './svg/creditCardIconMono.svg';

export interface ICreditCardProps {
	size?: number;
}

export function CreditCardIcon({ size = 24 }: ICreditCardProps) {
	const theme = useTheme();

	return (
		<CreditCardSVG
			width={size}
			height={size}
			color={theme.palette.primary.main}
			display="block"
		/>
	);
}
